import type { PropsWithChildren } from "react";
import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Badge } from "@similarweb/ui-components";

import type { SIBreadcrumbsVariant } from "app/pages/sales-intelligence/common-components/SIBreadcrumbs/SIBreadcrumbs";
import { SIBreadcrumbs } from "app/pages/sales-intelligence/common-components/SIBreadcrumbs/SIBreadcrumbs";
import { AI_SUPER_AGENT, HOME_PAGE_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

type Props = {
    variant?: SIBreadcrumbsVariant;
};

export const SuperAgentBreadcrumbs = ({ variant = "default", children }: PropsWithChildren<Props>) => {
    const { translate } = useTranslate();

    const breadcrumbsList = useMemo(
        () => [
            {
                state: HOME_PAGE_ROUTE,
                title: translate("si.ai-super-agent.breadcrumbs.home"),
            },
            {
                state: AI_SUPER_AGENT,
                title: translate("si.ai-super-agent.breadcrumbs.self"),
            },
        ],
        [translate],
    );

    const handleBreadcrumbClick = ({ state }: { state: string }) => {
        AIAgentTrackingService.superAgent.trackBreadcrumbClick();
        void proNavigator.go(state);
    };

    return (
        <SIBreadcrumbs
            variant={variant}
            list={breadcrumbsList}
            onClick={handleBreadcrumbClick}
        >
            <Badge type="beta" />
            {children}
        </SIBreadcrumbs>
    );
};
